// MealPreparationSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import mealPreparationImage from '../assets/meal-preparation-image.jpg';

const MealPreparationSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div>
            <img
              src={mealPreparationImage}
              alt="Carer preparing a meal with an elderly woman"
              className="w-full h-[420px] lg:h-[560px] rounded-2xl object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Everyday Nourishment
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              From Meal Preparation to Personal Care
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-8">
              <p>
                Nutrition plays a vital role in overall health, especially for seniors. Our compassionate carers are skilled in meal planning and preparation for diets that accommodate individual preferences, dietary restrictions, and health needs. Whether it is a low-sodium diet, diabetic-friendly meals, or soft food options, we tailor each plan to support our clients' wellness goals.
              </p>

              <p>
                For those who have difficulty feeding themselves due to age, illness, or disability, we provide gentle, respectful assistance to ensure they get the nourishment they need without stress or frustration.
              </p>

              <p>
                From grocery planning and meal preparation to gentle support at mealtimes, we are here to make every meal safe, comfortable, and enjoyable, because good food is an important part of living well.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call +61 420 162 243
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MealPreparationSection;
